import React from "react";
import Chart from "react-apexcharts";
import moment from "moment";

const AreaChart = ({data = [], colors = ["#3f51b5"],height = 90, width = "100%"}) => {
    // Generate default data if empty
    if (data.length === 0) {
        const now = moment();
        data = Array.from({length: 5}, (_, i) => ({
            dateCreated: now.clone().subtract(4 - i, "minutes").toISOString(),
            duration: 0,
        }));
    }

    // Sort data by dateCreated (oldest to newest)
    const sortedData = [...data].sort((a, b) => new Date(a.dateCreated) - new Date(b.dateCreated));

    const seriesData = sortedData.map((item) => ({
        x: moment(item.dateCreated).valueOf(),
        y: item.duration,
    }));

    const hasNonZeroValues = sortedData.some((d) => d.duration > 0);
    const minY = hasNonZeroValues ? undefined : -1;

    const options = {
        chart: {
            type: "area",
            sparkline: {enabled: true},
            toolbar: {show: false},
            zoom: {enabled: false},
            animations: {enabled: false},
        },
        yaxis: {
            min: minY,
            labels: {show: false},
            axisBorder: {show: false},
            axisTicks: {show: false},
        },
        xaxis: {
            type: "datetime",
            labels: {show: false},
            axisBorder: {show: false},
            axisTicks: {show: false},
        },
        grid: {show: false},
        fill: {
            type: "solid",
            opacity: 0.10,
        },
        colors,
        stroke: {curve: "smooth", width: 2},
        dataLabels: {enabled: false},
        markers: {size: 0},
        tooltip: {
            custom: function ({seriesIndex, dataPointIndex}) {
                const dataPoint = sortedData[dataPointIndex];
                if (!dataPoint || dataPoint.duration === null) {
                    return `
                        <div style="padding: 8px 12px; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.12);">
                            <div style="font-weight: 600; color: #999; font-size: 12px;">No data</div>
                        </div>
                    `;
                }
                const formattedDate = moment(dataPoint.dateCreated).format("DD MMM HH:mm");
                return `
                    <div style="padding: 8px 12px; background: white; border: 1px solid #e0e0e0; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.12); white-space: nowrap;">
                        <div style="font-weight: 600; margin-bottom: 4px; color: #333; font-size: 12px;">${formattedDate}</div>
                        <div style="color: #666; font-size: 13px;">Value: <strong>${dataPoint.duration}</strong></div>
                    </div>
                `;
            },
        },
    };
    return (
        <Chart
            options={options}
            series={[{name: "Duration", data: seriesData}]}
            type="area"
            height={height}
            width={width}
        />
    );
};

export default AreaChart;